/**
 * @file Toolbar.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 11th July 2019 10:32:32 am
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 * @flow
 */
import type { ID } from 'web-panel-essentials/types'
import type { ToolbarButton } from 'web-panel/types'

import * as React from 'react'
import { mix } from 'mixwith'
import { CAST } from 'web-panel-essentials/misc'
import ButtonList from './ButtonList'
import mList from '../utils/mList'

const sortByPriority = (a: ToolbarButton, b: ToolbarButton) => CAST.Number(b.priority) - CAST.Number(a.priority)

/**
 * React view for fast rendering button collection changes
 * @private
 * @class _ToolBar
 * @extends {React.Component}
*/
// $FlowFixMe[signature-verification-failure]
class Toolbar extends mix(React.Component).with(mList) {
  constructor (props: {parent: string}) {
    super(props)
    this.parent = props.parent
    this.updateStateImmediate = true
    this.state = {
      page: null,
      globalButtons: this.defineList('globalButtons'),
      localButtons: this.defineList('localButtons')
    }
  }

  changePage ({ id }: {id: ID}) : void {
    this.setState({ page: id })
  }

  async handleClick (button: ToolbarButton) {
    await button.action(button)
  }

  render () : React.Node {
    let { page, localButtons, globalButtons } = this.state
    localButtons = localButtons.filter(button => button.page === page).sort(sortByPriority)
    globalButtons = globalButtons.sort(sortByPriority)

    return (
      <div className='toolbar-buttons'>
        <div className='buttons-container'>
          <ButtonList onClick={this.handleClick} type='local' buttons={localButtons} />
          <ButtonList onClick={this.handleClick} type='global' buttons={globalButtons} />
        </div>
      </div>
    )
  }
}

export default Toolbar
